import { createContext } from 'react';

export type ChangeUserPasswordCtx = {
  showChangeUserPasswordSuccessAlert: boolean;
  showChangeUserPasswordErrorAlert: boolean;
  ChangeUserPasswordError: string;
};

const ChangeUserPasswordContext = createContext<ChangeUserPasswordCtx>({
  showChangeUserPasswordSuccessAlert: false,
  showChangeUserPasswordErrorAlert: false,
  ChangeUserPasswordError: '',
});

export default ChangeUserPasswordContext;
